
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { Check, X } from "lucide-react";

interface FeatureItem {
  name: string;
  free: string | boolean;
  pro: string | boolean;
  business: string | boolean;
  premium: string | boolean;
}

const features: FeatureItem[] = [
  {
    name: "Buchungen / Monat",
    free: "10",
    pro: "50",
    business: "300",
    premium: "∞"
  },
  {
    name: "Staff Accounts",
    free: "1",
    pro: "3",
    business: "10",
    premium: "∞"
  },
  {
    name: "Statistik & Dashboard",
    free: false,
    pro: true,
    business: true,
    premium: true
  },
  {
    name: "Add-on Verwaltung",
    free: false,
    pro: false,
    business: true,
    premium: true
  },
  {
    name: "Kalender Sync",
    free: false,
    pro: true,
    business: true,
    premium: true
  },
  {
    name: "Referral Tracking",
    free: false,
    pro: true,
    business: true,
    premium: true
  }
];

export function SubscriptionFeatureTable() {
  return (
    <div className="w-full overflow-auto">
      <Table className="w-full border-collapse">
        <TableHeader>
          <TableRow className="bg-chrona-gray-900/60">
            <TableHead className="py-3 px-4 text-left font-medium text-chrona-text">Feature</TableHead>
            <TableHead className="py-3 px-4 text-center font-medium text-chrona-text">Free</TableHead>
            <TableHead className="py-3 px-4 text-center font-medium text-chrona-text">Pro (19€)</TableHead>
            <TableHead className="py-3 px-4 text-center font-medium text-chrona-text">Business (39€)</TableHead>
            <TableHead className="py-3 px-4 text-center font-medium text-chrona-text">Premium (59€)</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {features.map((feature, index) => (
            <TableRow 
              key={index} 
              className={index % 2 === 0 ? "bg-chrona-gray-800/20" : "bg-chrona-gray-800/40"}
            >
              <TableCell className="py-3 px-4 font-medium">{feature.name}</TableCell>
              <TableCell className="py-3 px-4 text-center">
                {typeof feature.free === "boolean" ? (
                  feature.free ? 
                    <Check className="h-5 w-5 text-green-500 mx-auto" /> : 
                    <X className="h-5 w-5 text-red-500 mx-auto" />
                ) : (
                  feature.free
                )}
              </TableCell>
              <TableCell className="py-3 px-4 text-center">
                {typeof feature.pro === "boolean" ? (
                  feature.pro ? 
                    <Check className="h-5 w-5 text-green-500 mx-auto" /> : 
                    <X className="h-5 w-5 text-red-500 mx-auto" />
                ) : (
                  feature.pro
                )}
              </TableCell>
              <TableCell className="py-3 px-4 text-center">
                {typeof feature.business === "boolean" ? (
                  feature.business ? 
                    <Check className="h-5 w-5 text-green-500 mx-auto" /> : 
                    <X className="h-5 w-5 text-red-500 mx-auto" />
                ) : (
                  feature.business
                )}
              </TableCell>
              <TableCell className="py-3 px-4 text-center">
                {typeof feature.premium === "boolean" ? (
                  feature.premium ? 
                    <Check className="h-5 w-5 text-green-500 mx-auto" /> : 
                    <X className="h-5 w-5 text-red-500 mx-auto" />
                ) : (
                  feature.premium
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default SubscriptionFeatureTable;
